import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function PanelRight() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 28 28"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <rect width="18" height="18" x="3" y="3" rx="2" />
                <path d="M15 3v18" />
            </svg>
        </SvgIcon>
    );
}
